// PWA install + update + platform detection for Hussar Treasury.
// No credentials or sensitive data are ever involved in install metadata.

let deferredPrompt = null;
let swRegistration = null;

export const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

// Chrome/Firefox/Edge on iOS cannot install PWAs — only Safari can.
export const isIOSSafari = () =>
  isIOS() && /safari/i.test(navigator.userAgent) && !/crios|fxios|edgios|opt\//i.test(navigator.userAgent);

export function isInstalled() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export function canInstall() {
  return !!deferredPrompt;
}

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new Event("hussar-pwa-installable"));
});

window.addEventListener("appinstalled", () => {
  deferredPrompt = null;
  window.dispatchEvent(new Event("hussar-pwa-installed"));
});

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return choice.outcome === "accepted";
}

// ---- update handling: never silently serve obsolete financial logic ----

export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  const register = async () => {
    try {
      const reg = await navigator.serviceWorker.register("/service-worker.js");
      swRegistration = reg;
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new Event("hussar-pwa-update"));
          }
        });
      });
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    } catch { /* registration failed — app still works online */ }
  };
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register);
}

export async function applyUpdate() {
  navigator.serviceWorker.addEventListener("controllerchange", () => window.location.reload(), { once: true });
  const reg = swRegistration || (await navigator.serviceWorker.getRegistration());
  if (reg?.waiting) reg.waiting.postMessage("SKIP_WAITING");
  else window.location.reload();
}
